<template>
  <div class="wrapper mt-40">
    <h1>Impressum</h1>

    <h2 class="mt-12 mb-2">Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
    <p>
      Agnes &amp; Hanspeter Asal<br />
      Bergstra&szlig;e 14<br />
      79677 Aitern
    </p>

    <h3 class="mt-12 mb-2">Kontakt</h3>
    <p>
      Telefon:
      <a class="text-red-500" href="tel:+497673 7043">+49 (0) 7673 7043</a><br />
      E-Mail:
      <a class="text-red-500" href="mailto:info@haus-morgensonne.com"
        >info(at)haus-morgensonne.com</a
      ><br />
    </p>

    <h3 class="mt-12 mb-2">EU-Streitschlichtung</h3>
    <p>
      Die Europ&auml;ische Kommission stellt eine Plattform zur
      Online-Streitbeilegung (OS) bereit:
      <a
        class="text-red-500"
        href="https://ec.europa.eu/consumers/odr/"
        target="_blank"
        rel="noopener noreferrer"
        >https://ec.europa.eu/consumers/odr/</a
      >.<br />
      Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>

    <h3 class="mt-12 mb-2">
      Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
    </h3>
    <p>
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
      einer Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <p class="mt-12">
      Quelle:
      <a class="text-red-500" href="https://www.e-recht24.de">eRecht24</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Imprint',
}
</script>
